import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

declare const SAFE_ID_BRAND: unique symbol

/**
 * An entity ID checked safe to place inside a {@link Urn} segment, so a
 * caller-supplied scope value can't change which resource the URN names.
 *
 * For example, an ID must not contain:
 * - `:`, which opens a child segment
 * - `|`, which ends a URN in the reverse-index sort key
 * - `${`, which opens a scope placeholder
 *
 * Only {@link SafeId.isSafeId} produces one.
 */
export type SafeId = string & { readonly [SAFE_ID_BRAND]: true }
export namespace SafeId {
  /** The characters a {@link SafeId} may contain, and nothing else */
  export const PATTERN = /^[A-Za-z0-9_-]+$/

  export const isSafeId: TypeChecker<SafeId> = TypeChecker.Factory.custom(
    (val: unknown): val is SafeId =>
      typeof val === 'string' && PATTERN.test(val),
    { typeDescription: 'policy.SafeId' },
  )
  export const assertIsSafeId: TypeAsserter<SafeId> =
    TypeAsserter.Factory.from(isSafeId)
}
